module.exports = __webpack_public_path__ + "b775267bef9d2d0a22021dc1f58e12eb.svg";